import { useState } from "react";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { useQuery } from "@tanstack/react-query";
import { Fieldset } from "ui-components/Form";
import { FormTitle, DatePickerField, Text, SelectField } from "ui-components/Form";
import { getCarrierList } from "services/data.internal.service";
import { transportAgmtOptions,truckTypeOptions,manPowerRateOptions } from "layouts/views/common/options";
import { SwitchField } from "ui-components/Form";

function LoadManifest({ headerRender, control, errors, mode = "ADD" }) {
  const [carrierCodeOptions, setCarrierCodeOptions] = useState([]);

  useQuery({
    queryKey: ["carrier-options"],
    queryFn: () => getCarrierList({active:true}),
    onSuccess: (data) => setCarrierCodeOptions(data.data.data.map((x) => x.carrierCode)),
  });

  function renderFn(property, index, length) {
    const { size, disabled, editable, ...data } = property;
    const xs = 6/2
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
      ...(mode === "EDIT" && editable === false && { disabled: true, type: "text" }),
      //...(data.name === "shipPostcode" && { onChange: onShipPostcodeChange })
    };
    let renderField;
    switch (fieldProps.type) {
      case "text":
      case "number":
        renderField = <Text field={fieldProps} />;
        break;
      case "select":
        let options = [];
        let onChange = null;
        switch (data.name) {
          case "transportArrangement":
            options = transportAgmtOptions;
            break;
          case "truckType":
            options = truckTypeOptions;
            break;
          case "manPowerRate":
            options = manPowerRateOptions;
            break;
          case "carrier":
            options = carrierCodeOptions;
            break;
        }
        renderField = <SelectField field={fieldProps} options={options} onChange={onChange} />;
        break;
      case "date":
        renderField = <DatePickerField field={fieldProps} />;
        break;
      case "switch":
        renderField = <SwitchField field={fieldProps} />;
        break;
    }
    return (
      <Grid key={index} item xs={xs}>
        {renderField}
      </Grid>
    );
  }

  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit Load Manifest" : "Add Load Manifest"} />
      <MDBox mt={1.625}>
        {headerRender.map((rows, i) => {
          if (rows[0].type === "fieldset") {
            return (
              <Fieldset label={rows[0].label} key={i}>
                {rows[0].fieldsetRender.map((fs_rows, fs_i) => (
                  <Grid container spacing={3} key={fs_i}>
                    {fs_rows.map((fs_row, fs_index) => renderFn(fs_row, fs_index, fs_rows.length))}
                  </Grid>
                ))}
              </Fieldset>
            );
          }
          return (
            <Grid container spacing={3} key={i}>
              {rows.map((row, index) => renderFn(row, index, rows.length))}
            </Grid>
          );
        })}
      </MDBox>
    </MDBox>
  );
}

export default LoadManifest;
